import { Component, connect } from "macguffin"
import { setWinIterationComplete } from "game/redux/actions"
import BackgroundImage from "utils/BackgroundImage"

import { Tween } from "@tweenjs/tween.js"

const { atan2, PI, sqrt } = Math
const DEGREES = 180 / PI

const LINE_HEIGHT = 0.03 //1%
const POINT_SIZE = 0.09 //6%

const WINLINE_GRADIENT = "WINLINE_GRADIENT"

const WINLINE_ITERATION_DURATION = 1000

function getGradient() {
    return <defs>
        <linearGradient id={`${WINLINE_GRADIENT}`} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="rgb(126, 228, 247)" stopOpacity="0" />
            <stop offset="30%" stopColor="rgb(126, 228, 247)" stopOpacity="0.5"/>
            <stop offset="50%" stopColor="rgb(255, 255, 255)" stopOpacity="1"/>
            <stop offset="70%" stopColor="rgb(126, 228, 247)" stopOpacity="0.5"/>
            <stop offset="100%" stopColor="rgb(126, 228, 247)" stopOpacity="0"/>
        </linearGradient>
    </defs>
}

function renderLines(winlines, properties) {
    const { width, height, symbolWidth, symbolHeight, offsetX, offsetY } = properties

    const lineHeight = height * LINE_HEIGHT
    const halfLineHeight = lineHeight * 0.5

    return winlines.map((line, reelIndex) => {
        const symbolIndex = line
        const lines = []
        for (let i = 1, l = symbolIndex.length; i < l; i++) {
            const p1 = symbolIndex[i - 1]
            const p2 = symbolIndex[i]

            const p1x = ((i - 1) * symbolWidth) + offsetX
            const p1y = (p1 * symbolHeight) + offsetY

            const p2x = (i * symbolWidth) + offsetX
            const p2y = (p2 * symbolHeight) + offsetY

            const dx = p2x - p1x
            const dy = p2y - p1y
            const d = sqrt(dx * dx + dy * dy)
            const rotation = dy ? atan2(dy, dx) * DEGREES : 0

            const py = p1y - halfLineHeight

            lines.push(<rect
                key = {`${i}`}
                width = {`${d}px`}
                height = {`${lineHeight}px`}
                x = {`${p1x}px`}
                y = {`${py}px`}
                transform = {`rotate(${rotation}, ${p1x}, ${py})`}
                strokeWidth = "0px"
                fill = {`url(#${WINLINE_GRADIENT})`}
            />)
        }
        return <g key={`line${reelIndex}`}> { lines } </g>
    })
}

function renderPoints(winlines, properties) {
    const { width, height, symbolWidth, symbolHeight, offsetX, offsetY } = properties

    const pointSize = height * POINT_SIZE
    const halfPointSize = pointSize * 0.5

    return winlines.map((line, lineIndex) => {
        return line.map((point, index) => {
            const style = {
                position: "absolute",
                width: `${pointSize}px`,
                height: `${pointSize}px`,
                left: `${(index * symbolWidth) + offsetX - halfPointSize}px`,
                top: `${(point * symbolHeight) + offsetY - halfPointSize}px`,
                backgroundPosition: "center"
            }

            return <BackgroundImage
                className="winlineDot"
                assetName="winlineDot"
                key = {index}
                style = {style}
            />
        })
    })
}

@connect(state => ({
	reelStoppedIndex: state.game.reelStoppedIndex,
	currentWinData: state.game.currentWinData,
    currentWinIteration: state.game.currentWinIteration
}),{
    setWinIterationComplete
})

export default class Winlines extends Component {

    constructor() {
        super()

        this.state = {
            gradient: getGradient()
        }
    }

	componentWillReceiveProps(nextProps) {
		const currentProps = this.props

        if (nextProps.currentWinData !== currentProps.currentWinData) {
            if (!nextProps.currentWinData) {
                this.setState({ winlines: undefined })
            } else {
                const { currentWinData } = nextProps

                const winlines = currentWinData.map((winData) => {
                    return winData.lineIndices
                })

                this.setState({ winlines })
            }
        } else if (nextProps.currentWinIteration !== currentProps.currentWinIteration) {
            const { currentWinData, currentWinIteration } = nextProps

            const currentWinline = currentWinData[currentWinIteration]
            const { lineIndices } = currentWinline

            this.setState({ winlines: [ lineIndices ] }, this.setIterationComplete)
        }
	}

    setIterationComplete = () => {
        const { props } = this

        const timeout = new Tween()
            .to({}, WINLINE_ITERATION_DURATION)
            .onComplete(() => {
                props.setWinIterationComplete()
            })
            .start()
    }

	render () {
		const { left, top, width, height, visibility } = this.props
        const { winlines, gradient, show } = this.state || {}

        const style = {
            top: `${top}px`,
            left: `${left}px`,
            visibility
        }

        const symbolWidth = width / 5
        const symbolHeight = height / 3

        const offsetX = symbolWidth * 0.5
        const offsetY = symbolHeight * 0.5

        const lineProperties = {
            width,
            height,
            symbolWidth,
            symbolHeight,
            offsetX,
            offsetY
        }

        return <div className="winlinesContainer" style={style}>
            <svg key="winlinesGraphic" width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
                { gradient }
                { winlines && renderLines(winlines, lineProperties) }
            </svg>
            { winlines && renderPoints(winlines, lineProperties) }
		</div>
	}
}
